// src/components/DesignationMembersAdmin/DesignationMembersAdmin.js
import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  Badge,
  Modal,
} from "react-bootstrap";
import { adminGet, adminDelete } from "../../../Services";
import districtData from "../../../assets/districts.json";
import { toast } from "react-toastify";

const DesignatedMembers = () => {
  const states = [
    "Andaman and Nicobar",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Ladakh",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Puducherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];

  const [scope, setScope] = useState("");
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [block, setBlock] = useState("");
  const [districts, setDistricts] = useState([]);
  const [blocks, setBlocks] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [status, setStatus] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState(null);

  // Fetch assignments and status when scope/location changes
  useEffect(() => {
    // if (state || district ||block) {
    //   fetchAssignments();
    //   fetchStatus();
    // } else {
    //   // Clear data when no scope is selected
    //   setAssignments([]);
    //   setStatus([]);
    // }
    if (scope) {
      setAssignments([]);
      setStatus([]);
      // setState("");
      // setDistrict("");
      // setBlock("");
    }
    if (scope === "National") {
      fetchAssignments();
      fetchStatus();
    }
    if (scope === "State") {
      if (state) {
        fetchAssignments();
        fetchStatus();
      }
    } else if (scope === "District") {
      if (district) {
        fetchAssignments();
        fetchStatus();
      }
    } else if (scope === "Block") {
      if (block) {
        fetchAssignments();
        fetchStatus();
      }
    }
  }, [scope, state, district, block]);

  const fetchAssignments = async () => {
    setLoading(true);
    try {
      const params = {};
      // if (scope === "National") console.log("National");
      if (scope) params.scope = scope;
      if (state) params.state = state;
      if (district) params.district = district;
      if (block) params.block = block;

      const response = await adminGet(
        "/api/designation-assignments/admin",
        params
      );
      setAssignments(response.data);
    } catch (err) {
      console.error("Error fetching assignments:", err);
      toast.error("Failed to load assignments");
    } finally {
      setLoading(false);
    }
  };

  const fetchStatus = async () => {
    try {
      const params = { scope };
      if (state) params.state = state;
      if (district) params.district = district;
      if (block) params.block = block;

      const response = await adminGet(
        "/api/designation-assignments/status",
        params
      );
      setStatus(response.data);
    } catch (err) {
      console.error("Error fetching status:", err);
      toast.error("Failed to load status");
    }
  };

  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    setState(selectedState);
    setDistrict("");
    setBlock("");

    const filteredDistricts = districtData.districts.filter(
      (d) => d.state === selectedState
    );
    setDistricts(filteredDistricts);
    setBlocks([]);
  };

  const handleDistrictChange = async (e) => {
    const selectedDistrict = e.target.value;
    setDistrict(selectedDistrict);
    setBlock("");

    if (!state) return;

    try {
      const blocksFile = await import(
        `../../../assets/BlocksList/${state.replace(/\s/g, "")}.json`
      );
      const districtBlocks = blocksFile[selectedDistrict] || [];
      setBlocks(districtBlocks);
    } catch (error) {
      console.error("Block list not found for this state:", error);
      setBlocks([]);
    }
  };

  const handleRemoveAssignment = async (assignmentId) => {
    if (!window.confirm("Are you sure you want to remove this assignment?")) {
      return;
    }

    try {
      await adminDelete(`/api/designation-assignments/${assignmentId}`);
      toast.success("Assignment removed successfully");
      fetchAssignments();
      fetchStatus();
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to remove assignment");
    }
  };

  const handleScopeChange = (e) => {
    const newScope = e.target.value;
    setScope(newScope);

    // Reset location fields when scope changes
    if (newScope === "National") {
      setState("");
      setDistrict("");
      setBlock("");
      setDistricts([]);
      setBlocks([]);
    } else if (newScope === "State") {
      setDistrict("");
      setBlock("");
      setDistricts([]);
      setBlocks([]);
    } else if (newScope === "District") {
      setBlock("");
      setBlocks([]);
    }
  };

  const handleShowDetails = (assignment) => {
    setSelectedAssignment(assignment);
    setShowDetailsModal(true);
  };

  return (
    <Container className="">
      <h3 className="fw-medium" style={{ color: "#1a5276" }}>
        Designated Members
      </h3>

      <Card className="mb-4">
        <Card.Header>
          <h5 className="mb-0">Filter Assignments</h5>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>Scope</Form.Label>
                <Form.Select value={scope} onChange={handleScopeChange}>
                  <option value="">Select Scope</option>
                  <option value="National">National</option>
                  <option value="State">State</option>
                  <option value="District">District</option>
                  <option value="Block">Block</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {scope && scope !== "National" && (
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>State</Form.Label>
                  <Form.Select
                    value={state}
                    onChange={handleStateChange}
                    required={scope !== "National"}
                  >
                    <option value="">Select State</option>
                    {states.map((s) => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}

            {scope && (scope === "District" || scope === "Block") && (
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>District</Form.Label>
                  <Form.Select
                    value={district}
                    onChange={handleDistrictChange}
                    disabled={!state}
                    required={scope === "District" || scope === "Block"}
                  >
                    <option value="">Select District</option>
                    {districts.map((d) => (
                      <option key={d.district} value={d.district}>
                        {d.district}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}

            {scope && scope === "Block" && (
              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Block</Form.Label>
                  <Form.Select
                    value={block}
                    onChange={(e) => setBlock(e.target.value)}
                    disabled={!district}
                    required={scope === "Block"}
                  >
                    <option value="">Select Block</option>
                    {blocks.map((b) => (
                      <option key={b} value={b}>
                        {b}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>

      {loading ? (
        <div className="text-center py-4">
          <p>Loading assignments...</p>
        </div>
      ) : (
        <Row>
          <Col md={8}>
            <Card className="mb-4">
              <Card.Header>
                <h5 className="mb-0">Current Assignments</h5>
              </Card.Header>
              <Card.Body>
                {!scope ? (
                  <p className="text-muted text-center py-4">
                    Please select a scope to view assignments
                  </p>
                ) : assignments.length === 0 ? (
                  <p className="text-muted text-center py-4">
                    No assignments found for the selected criteria
                  </p>
                ) : (
                  <Row>
                    {assignments.map((assignment) => (
                      <Col md={6} lg={4} key={assignment.id} className="mb-3">
                        <Card className="h-100">
                          <Card.Body>
                            <div className="d-flex align-items-center mb-2">
                              <Badge bg="primary" className="me-2">
                                {assignment.Designation?.name}
                              </Badge>
                              <Badge bg="secondary">{assignment.level}</Badge>
                            </div>

                            <h6 className="mb-1">{assignment.Member?.name}</h6>
                            <p className="text-muted small mb-1">
                              ID: {assignment.Member?.registration_id}
                            </p>
                            <p className="text-muted small mb-2">
                              {assignment.Member?.profession}
                            </p>

                            <div className="text-muted small mb-3">
                              {assignment.state && `State: ${assignment.state}`}
                              {assignment.district &&
                                `, District: ${assignment.district}`}
                              {assignment.block &&
                                `, Block: ${assignment.block}`}
                            </div>

                            <div className="d-flex gap-2">
                              <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => handleShowDetails(assignment)}
                              >
                                View Details
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() =>
                                  handleRemoveAssignment(assignment.id)
                                }
                              >
                                Remove
                              </Button>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                )}
              </Card.Body>
            </Card>
          </Col>

          <Col md={4}>
            <Card>
              <Card.Header>
                <h5 className="mb-0">Designation Status</h5>
              </Card.Header>
              <Card.Body>
                {!scope ? (
                  <p className="text-muted text-center py-4">
                    Please select a scope to view status
                  </p>
                ) : status.length === 0 ? (
                  <p className="text-muted text-center py-4">
                    No status information available
                  </p>
                ) : (
                  <div>
                    {status.map((item) => (
                      <div
                        key={item.designationId}
                        className="mb-3 p-2 border rounded"
                      >
                        <h6 className="mb-1">{item.name}</h6>
                        <div className="d-flex justify-content-between small text-muted">
                          <span>Filled: {item.currentCount}</span>
                          <span>Remaining: {item.remainingSlots || "0"}</span>
                        </div>
                        {item.maxCount && (
                          <div
                            className="progress mt-1"
                            style={{ height: "8px" }}
                          >
                            <div
                              className="progress-bar"
                              role="progressbar"
                              style={{
                                width: `${
                                  (item.currentCount / item.maxCount) * 100
                                }%`,
                              }}
                              aria-valuenow={item.currentCount}
                              aria-valuemin="0"
                              aria-valuemax={item.maxCount}
                            ></div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {selectedAssignment && (
        <Modal
          show={showDetailsModal}
          onHide={() => setShowDetailsModal(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Member Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={4} className="text-center">
                <img
                  src={`${selectedAssignment.Member?.photo_url}`}
                  alt={selectedAssignment.Member?.name}
                  className="img-fluid rounded"
                  style={{ maxHeight: "200px", objectFit: "cover" }}
                  onError={(e) => {
                    e.target.src =
                      "https://via.placeholder.com/200x200/f5f5f5/999999?text=No+Image";
                  }}
                />
              </Col>
              <Col md={8}>
                <h4>{selectedAssignment.Member?.name}</h4>
                <p className="text-muted">
                  {selectedAssignment.Member?.profession}
                </p>

                <div className="mb-3">
                  <Badge bg="primary" className="me-2">
                    {selectedAssignment.Designation?.name}
                  </Badge>
                  <Badge bg="secondary">{selectedAssignment.level} Level</Badge>
                </div>

                <Row>
                  <Col md={6}>
                    <p>
                      <strong>Registration ID:</strong>
                      <br />
                      {selectedAssignment.Member?.registration_id}
                    </p>
                    <p>
                      <strong>Mobile:</strong>
                      <br />
                      {selectedAssignment.Member?.mobile_no}
                    </p>
                    {selectedAssignment.Member?.email && (
                      <p>
                        <strong>Email:</strong>
                        <br />
                        {selectedAssignment.Member?.email}
                      </p>
                    )}
                  </Col>
                  <Col md={6}>
                    <p>
                      <strong>Location:</strong>
                      <br />
                      {selectedAssignment.state &&
                        `${selectedAssignment.state}`}
                      {selectedAssignment.district &&
                        `, ${selectedAssignment.district}`}
                      {selectedAssignment.block &&
                        `, ${selectedAssignment.block}`}
                    </p>
                    <p>
                      <strong>Member From:</strong>
                      <br />
                      {selectedAssignment.Member?.state &&
                        `${selectedAssignment.Member?.state}`}
                      {selectedAssignment.Member?.district &&
                        `, ${selectedAssignment.Member?.district}`}
                      {selectedAssignment.Member?.block &&
                        `, ${selectedAssignment.Member?.block}`}
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowDetailsModal(false)}
            >
              Close
            </Button>
            <Button
              variant="outline-danger"
              onClick={() => {
                setShowDetailsModal(false);
                handleRemoveAssignment(selectedAssignment.id);
              }}
            >
              Remove Assignment
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Container>
  );
};

export default DesignatedMembers;
